import Imported from 'react-imported-component';
const Home = Imported(() => import('../../container/home/Home'));
import NotFound from '../../container/404';
import Login from '../../container/login/Login';
import Test from '../../container/test/Test';
import Preload from '../../container/home/Preload';
import ArticleList from '../../container/ArticleList/ArticleList';
import CreateArticle from '../../container/CreateArticle';
import UpdateArticle from '../../container/UpdateArticle';
import ArticleDetail from '../../container/ArticleDetail/ArticleDetail';
import QuestionList from '../../container/QuestionList';
import CreateQuestion from '../../container/QuestionCreate';
import QuestionEdit from '../QuestionAnswer';
import QuestionResponse from '../../container/QuestionResponse';
import CreateVideo from '../../container/CreateVideo';
import VideoList from '../../container/VideoList';
import CreatePics from '../../container/CreatePics';
import PicsList from '../../container/PicsList';
import PostsDetail from '../../container/PostsDetail';
import QuestionDetail from '../../container/QuestionDetail';
import CreateEditPics from '../CreateEditPics';
import EditPicsList from '../EditPicsList';
// import PrivateLetter from '../PrivateLetter';

export default [
    {
        path: '/test',
        component: Test,
    },
    {
        path: '/preload',
        component: Preload,
    },
    {
        path: '/login',
        component: Login,
    },
    {
        path: '/detail/:id',
        component: ArticleDetail,
        exact: true,
    },
    {
        path: '/posts/detail/:id',
        component: PostsDetail,
        exact: true,
    },
    {
        path: '/question/detail/:id',
        component: QuestionDetail,
        exact: true,
    },
    {
        path: '/404',
        component: NotFound,
        exact: true,
        slider: false
    },
    {
        path: '/',
        component: Home,
        childRoutes: [
            // {
            //     path: '/channel',
            //     component: PrivateLetter,
            //     exact: true,
            // },
            {
                path: '/edit-pics/create',
                component: CreateEditPics,
                exact: true,
            },
            {
                path: '/edit-pics',
                component: EditPicsList,
                exact: true,
            },
            {
                path: '/pics',
                component: PicsList,
                exact: true,
            },
            {
                path: '/pics/create',
                component: CreatePics,
                exact: true,
            },
            {
                path: '/video',
                component: VideoList,
                exact: true,
            },
            {
                path: '/video/create',
                component: CreateVideo,
                exact: true,
            },
            {
                path: '/question/response',
                component: QuestionResponse,
                exact: true,
            },
            {
                path: '/question/response/:id',
                component: QuestionEdit,
                exact: true,
            },
            {
                path: '/question/create',
                component: CreateQuestion,
                exact: true,
            },
            {
                path: '/question',
                component: QuestionList,
                exact: true,
            },
            {
                path: '/create', // type:public、draft
                component: CreateArticle,
                exact: true,
            },
            {
                path: '/update/:id', // type:public、draft
                component: UpdateArticle,
                exact: true,
            },
            {
                path: '/',
                component: ArticleList,
                exact: true,
            },
            {
                path: '*',
                component: NotFound,
                exact: true,
                isNoFound: true
            },
        ],
    },
];
